import styled from "styled-components";
import { useWindowSize } from "../../../common/hooks/useWindowSize";
import { Column, SizedBox } from "../../../common/components/CommonBaseComponents";
import TicketChartDashboardCard from "./TicketChartDashboardCard";
import RemainTicketListDashboardCard from "./RemainTicketListDashboardCard";
import BookmarkedShopDashboardCard from "./BookmarkedShopDashboardCard";

const BottomTextCardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    height: 100%;
    gap: 17px;
`;

function CallCenterDashboardArea() {
    const { width } = useWindowSize();

    if (width <= 1970) {
        return (
            <>
                <TicketChartDashboardCard />
                <SizedBox height={"16px"} />
                <RemainTicketListDashboardCard />
                <SizedBox height={"16px"} />
                <BookmarkedShopDashboardCard />
            </>
        );
    }

    return (
        <BottomTextCardGrid>
            <Column width={"100%"}>
                <TicketChartDashboardCard />
                <SizedBox height={"16px"} />
                <RemainTicketListDashboardCard />
            </Column>
            <BookmarkedShopDashboardCard />
        </BottomTextCardGrid>
    );
}

export default CallCenterDashboardArea;
